export default "__VITE_ASSET__RFA9jtZl__"